import { useEffect, useState } from 'react';

import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import { Footer } from 'darrius';

import {
  ProspectDepoimentsData,
  ProspectHowWorksData,
} from '../../data/home/homeData';

import { Header } from '../../components/atoms';
import { HeadContent, HowMuch, WhyUs } from '../../components';

import { ProspectHero } from '../../components/organisms/ProspectHero/ProspectHero';
import { Benefits } from '../../components/organisms/Benefits/Benefits';
import { HowWorks } from '../../components/organisms/HowWorks/HowWorks';
import { Depoiments } from '../../components/organisms/Depoiments/Depoiments';

import { type TStaticContent } from '../@interfaces';
import { clientCookie } from '@/utils/clientCookie';

interface IProspectTemplateHomeProps {
  staticContent: TStaticContent;
}

const FlowOptimizationDialog = dynamic(
  () => import('./FlowOptimizationDialog/FlowOptimizationDialog'),
  { ssr: false }
);

export default function ProspectTemplateHome(
  props: IProspectTemplateHomeProps
) {
  const router = useRouter();

  const [
    shouldShowFlowOptimizationDialog,
    setShouldShowFlowOptimizationDialog,
  ] = useState(true);

  const { staticContent } = props;
  const { footerContent } = staticContent;

  const { query } = useRouter();

  useEffect(() => {
    if (query?.utm_source && typeof query.utm_source === 'string') {
      const utmSource = query.utm_source.trim().toLocaleLowerCase();
      if (utmSource === 'modal_cli') {
        setShouldShowFlowOptimizationDialog(false);
      }
    }
  }, [query]);

  useEffect(() => {
    const gclid = router?.query?.gclid;
    const msclkid = router?.query?.msclkid;
    const routerUrl = encodeURI(router.asPath);
    const urlHasAnyQueryParams = router.asPath.includes('?');

    if (gclid) {
      clientCookie.set('gclid', String(gclid), 1);
    }

    if (msclkid) {
      clientCookie.set('msclkid', String(msclkid), 1);
    }

    if (urlHasAnyQueryParams) {
      clientCookie.set('router_url', routerUrl, 1);
    }
  }, [router?.query?.gclid, router?.query?.msclkid]);

  return (
    <>
      <HeadContent
        metaTitle="GetNinjas | Orçamento de Profissionais Confiáveis no GetNinjas.com.br"
        slug="Anuncie"
        metaDescription="Encontre profissionais confiáveis para pintar, reformar, traduzir um texto, te ensinar matemática, ou também passear com seu cachorro no GetNinjas"
        type="prospect:home"
      />

      <Header.Simple />

      <ProspectHero />

      <HowWorks buttonText={ProspectHowWorksData.buttonText} buttonLink="#cadastro" />

      <Benefits />

      <HowMuch />

      <WhyUs />

      <Depoiments reviews={ProspectDepoimentsData.reviews} />

      <Footer data={footerContent} />

      {shouldShowFlowOptimizationDialog && <FlowOptimizationDialog />}
    </>
  );
}
